import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ReferralActivity,
  InstapointsSection,
  InstapointsSectionHeader,
  ActivityText,
  LeftHeader,
  RightHeader,
  ReferAndEarnWrapper,
  RefferalContainer,
  ReferralBanner
} from './styles';
import { REFER_STATUS_FILTER, INSTAPOINTS_URL } from '../../utils/constants';
import CustomTabs from './custom-tabs/CustomTabs';
import ReferHistory from './refer-history/referHistory';
import { getReferralLabels, getRewardData } from './utils';
import { History, iProps } from './interface';
import { getSourceCurrencies } from '../../redux/actions/common/common-action';
import ReferCard from './refer-card/referCard';
import { formatCurrencyToTwoDecimalPlaces } from '../../utils/library';
import { EVENT_ROUTE_KEYS, EventNamesV2 } from '@Utils/events/eventsConstants';
import { logEventV2 } from '@Utils/events/logUserEvents';
import InstaPointsHeader from '../referrals-instapoints/InstaPointsHeader';
import useUniformReferralEnabled from '../../hooks/useUniformReferralEnabled';

const ReferAndEarn: React.FC<iProps> = ({
  referandEarnSchema,
  countryCode,
  redemptionValue,
  initialReferralInstapoint,
  transactionReferralInstapoint,
  totalInstapoints,
  instapointsEarnedCurrentMonth,
  instapointsExpiringCurrentMonth,
  ipBalanceTransactions,
  ipBalanceReferral,
  url,
  historyData
}): React.ReactElement => {
  const navigate = useNavigate();
  const [currency, setCurrency] = useState('');
  const [history, setHistory] = useState<History[]>([]);
  const [active, setActive] = useState(REFER_STATUS_FILTER[0].id);

  const handleRedeemClick = () => {
    navigate(INSTAPOINTS_URL);
  };

  const filterHistory = (tabId: string) => {
    const tempHistory: History[] = historyData.filter((item) => {
      if (tabId === 'pending' && (item.status === 'Joined' || item.status === 'Code used'))
        return true;
      else if (tabId === 'completed' && item.status === 'Completed') return true;
      else if (tabId === 'all') return true;
      return false;
    });
    return tempHistory;
  };

  const getCurrency = async () => {
    if (countryCode) {
      try {
        const currency = await getSourceCurrencies(countryCode);
        setCurrency(currency?.data?.data[0]?.key);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };

  useEffect(() => {
    logEventV2(EventNamesV2.SCREEN_VIEWED, {
      pageName: EVENT_ROUTE_KEYS.ReferAndEarn
    });
  }, []);

  useEffect(() => {
    getCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  useEffect(() => {
    const tempHistory = filterHistory('pending');
    setHistory(tempHistory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyData]);

  const handleTabClick = (tabId: string) => {
    setActive(tabId);
    const tempHistory: History[] = filterHistory(tabId);
    setHistory(tempHistory);
  };

  const initialRedeemValue = formatCurrencyToTwoDecimalPlaces(
    redemptionValue * initialReferralInstapoint
  ).toString();
  const transactionalRedeemValue = formatCurrencyToTwoDecimalPlaces(
    redemptionValue * transactionReferralInstapoint
  ).toString();
  const initialIPValue = formatCurrencyToTwoDecimalPlaces(initialReferralInstapoint).toString();
  const { isEnabled: isUniformReferralEnabled } = useUniformReferralEnabled();
  const labels = getReferralLabels(referandEarnSchema, countryCode);

  const rewardData = getRewardData(
    referandEarnSchema,
    currency,
    initialIPValue,
    initialRedeemValue,
    transactionalRedeemValue,
    transactionReferralInstapoint
  );

  return (
    <ReferAndEarnWrapper>
      <ReferralBanner>
        <h1 className="heading">{labels?.webPageTitle}</h1>
      </ReferralBanner>
      <RefferalContainer>
        <ReferCard
          rewardData={rewardData}
          labels={labels}
          url={url}
          currency={currency}
          countryCode={countryCode}
        ></ReferCard>
        {isUniformReferralEnabled && (
          <InstapointsSection>
            <InstapointsSectionHeader>
              <LeftHeader>{labels?.instapointsSection?.heading}</LeftHeader>
              <RightHeader onClick={handleRedeemClick}>
                {labels?.instapointsSection?.headingRight}
              </RightHeader>
            </InstapointsSectionHeader>
            <div>
              <InstaPointsHeader
                headerTitle={false}
                ip_balance={totalInstapoints}
                ip_balance_transactions={ipBalanceTransactions}
                ip_balance_referral={ipBalanceReferral}
                ip_redemption_value={redemptionValue}
                ip_earned_current_month={instapointsEarnedCurrentMonth}
                ip_expired_current_month={instapointsExpiringCurrentMonth}
              />
            </div>
          </InstapointsSection>
        )}
        <ReferralActivity>
          <ActivityText>{labels?.referralActivitySection?.heading}</ActivityText>
          <div>
            <CustomTabs tabs={REFER_STATUS_FILTER} onTabClick={handleTabClick} activeTab={active} />
          </div>
          <div>
            <ReferHistory historyData={history} labels={labels} url={url}></ReferHistory>
          </div>
        </ReferralActivity>
      </RefferalContainer>
    </ReferAndEarnWrapper>
  );
};

export default ReferAndEarn;
